<template>
    <OrderReviewRow
        v-if="showDiscount"
        :label="discountLabel"
        :value="$n(-discountDollarAmount, 'currency')"
    />
</template>

<script>
import { DISCOUNT_TYPES } from '../../money.constants';
import OrderReviewRow from '../order/OrderReviewRow.vue';

export default {
    components: {
        OrderReviewRow,
    },

    props: {
        invoice: {
            type: Object,
            default: () => {
                return {
                    totalPaid: 0,
                    total: 0,
                    payPlan: {
                        amountDue: 0,
                        percentDue: 0,
                    },
                };
            },
        },
    },

    computed: {
        showDiscount() {
            return this.hasDiscount;
        },

        discountLabel() {
            if (this.hasPercentDue) {
                return this.$t('InvoiceDiscount.percentDiscount', { percent: this.invoice.discount.amount });
            }

            return this.hasDiscount ? this.$t('InvoiceDiscount.discount') : this.$t('InvoiceDiscount.addDiscount');
        },

        hasDiscount() {
            return Boolean(this.invoice && this.invoice.discount && this.invoice.discount.amount);
        },

        hasPercentDue() {
            return Boolean(this.hasDiscount && this.invoice.discount.discountMethod === DISCOUNT_TYPES.percent);
        },

        hasAmountDue() {
            return Boolean(this.hasDiscount && this.invoice.discount.discountMethod === DISCOUNT_TYPES.amount);
        },

        discountDollarAmount() {
            if (this.hasPercentDue) {
                return this.invoice.subTotalAmount * this.invoice.discount.amount / 100;
            }

            if (this.hasAmountDue) {
                return this.invoice.discount.amount;
            }

            return 0;
        },
    },
};
</script>
